"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var AcdcContext_1 = require("./AcdcContext");
function useAcdcLabelProps() {
    var _a = AcdcContext_1.useAcdcElementRegistryContext(), inputId = _a.inputId, labelId = _a.labelId;
    return react_1.useMemo(function () { return [{
            id: labelId,
            htmlFor: inputId,
        }]; }, [labelId, inputId]);
}
exports.default = useAcdcLabelProps;
